/*
 * Skip Link Atom Component
 *
 * Reach UI 'skip-nav' component: https://reacttraining.com/reach-ui/skip-nav
 * Used in `src/5_Templates/PageTemplate` with `import { SkipNavContent } from "@reach/skip-nav"` to target main content
 */

import React from "react"
import { SkipNavLink } from "@reach/skip-nav"

const SkipLink = () => {
  return (
    <SkipNavLink className={`skip-link`}>
      Skip navigation and go to main content
    </SkipNavLink>
  )
}

export default SkipLink
